import { dbPromise } from './db'

import type { CacheArgs, PersistedEntry } from './types'

export async function getCache<T>(key: string, { dbName, storeName, version }: CacheArgs) {
  const db = await dbPromise(dbName, storeName)

  const item = (await db.get(storeName, key)) as PersistedEntry<T> | undefined

  if (!item) return null

  if (item.version !== version) {
    await db.delete(storeName, key)

    return null
  }

  if (Date.now() > item.expiresAt) {
    await db.delete(storeName, key)

    return null
  }

  return item
}

export async function setCache<T>(entry: PersistedEntry<T>, dbName: string, storeName: string) {
  const db = await dbPromise(dbName, storeName)

  await db.put(storeName, entry)
}

export async function removeCache(key: string, dbName: string, storeName: string) {
  const db = await dbPromise(dbName, storeName)

  await db.delete(storeName, key)
}

export async function clearAllCache(dbName: string, storeName: string) {
  const db = await dbPromise(dbName, storeName)

  await db.clear(storeName)
}
